var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain"},[_c('p',[_vm._v(_vm._s(this.body))]),_c('CardActions',[_c('Button',{attrs:{"label":this.$i18n.t('go_no_go_button_continue')},on:{"click":_vm.hideModal}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }